import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CheckBox from 'components/form/Checkbox';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';

const CONTRACT_URL = `https://weadmit-static.s3.us-east-2.amazonaws.com/contracts/`;

const Agreement = ({ onChange, tos, product, upgrade, onBack, onNext }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography gutterBottom variant="h5">Agree to the Contract</Typography>
      <Box marginTop={3} maxWidth="80%">
        <CheckBox
          color="primary"
          checked={tos}
          onChange={(e) => onChange('tos', e.target.checked)}
          label={
            <Typography color="textSecondary">
                I confirm that I am the student’s parent or legal guardian, and
                I have read and agree to the{' '}
              <Link
                target="_blank"
                href={`${CONTRACT_URL}${product.contract_filename}`}
              >
                  <strong>{product.package_name} Contract</strong>
                </Link>
              </Typography>
          }
        />
      </Box>
     {upgrade && <Box display="flex" justifyContent="space-between">
          <Button color="primary" onClick={onBack}>
            Back
          </Button>
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={onNext}
          >
            I Agree
          </Button>
        </Box>}
    </Box>
  );
};

export default Agreement;
